import moment from 'moment'

import CS from './Common'

class Moment {

    lastDayInMonth(year, month) {
        let a = moment(`${year}-` + CS.fillZero(2, month) + `-01`);
        return a.daysInMonth();
    }

    isToday(d) {
        return (moment(d).isSame(this.format(new Date(), 'YYYY-MM-DD'))) 
    }


    /**
     * @param {*} d 
     * @param {*} fmt 
     * YYYY-MM-DD
     * YYYY-MM-DD HH:mm
     * YYYY-MM-DD HH:mm:Z
     * YYYY-MM-DD HH:mm [UTC]Z
     * YYYY년 M월 D일 HH:mm
     * dddd, MMMM [the] Do, YYYY
     */
    format(d, fmt) {
        return moment(d).format(fmt);
    }

    add(d, num, type) {
        return moment(d).add(num, type).toDate();
    }

    addAndFormat(d, num, type, fmt) {
        return moment(d).add(num, type).format(fmt);
    }

    toDate(str, fmt) {
        return moment(str, fmt).toDate();
    }

    current(fmt) {
        return moment().format(fmt);
    }

    currentQuarter() {
        return moment().quarter();
    }

    getQuarter(str) {
        return moment(str).quarter();
    }

    isValidDate(str, fmt) {
        return moment(str, fmt, true).isValid();
    }

    startOf(d, type, fmt) {
        return moment(d).startOf(type).format(fmt);
    }

    endOf(d, fmt) {
        return moment(d).endOf('month').format(fmt);
    }

    diff(start, end, type) {
        return moment(end).diff(moment(start), type);
    }

}

export default new Moment()
